import Card from 'react-bootstrap/Card';
import Row from 'react-bootstrap/Row';
import ReportHeader from './ReportHeader';
import ReportChart from './ReportChart';
import ReportData from './ReportData';


export default function ReportViewer( { selectedReport, filters, data, schema } ) {
    if (!selectedReport) {
        return <p className="text-muted">Please select a report from the sidebar.</p>;
    }

    return (
        <Card>
            <Card.Body>
                {/* Header */}
                <ReportHeader
                    selectedReport={selectedReport}
                    filters={filters}
                />

                {/* Chart/Graph */}
                <Row className="my-3">
                    <ReportChart reportType={selectedReport.id} data={data} filters={filters} reportConfig={selectedReport} />
                </Row>

                {/* Data table + export */}
                <Row className="mt-3">
                    <ReportData selectedReport={selectedReport} schema={schema} data={data} />
                </Row>
            </Card.Body>
        </Card>
    );
}